// 查询字典
export const baseurl = {
    // 生产
    // base : 'https://scpms.sinopec.com/mobile',
    // url: 'https://scpms.sinopec.com/yun',
    // isTest: false,
    // 测试
	//url: 'http://10.252.127.8:7001/',
    url: 'http://10.213.116.101:9081',
	//url: 'http://192.168.137.1:5509',
    msign : '/msign',
	
	sealurl: 'http://10.213.116.101:9081',
	
	seal:'/seal',
    // base : 'http://localhost:8070/mobile',
    isTest : true,  //是否是测试
};

